var exports = {
  "x": "xaf9ae18d--91af2a--button",
};

module.exports = exports;
